"use client";

/**
 * PostDetailRelatedCard 컴포넌트
 * @description "More stories" 한 장 — 누르면 어디서 어디로 갔는지 남긴다. 카드는 링크라
 *   이동은 브라우저가 하고 계측만 곁에서 한다.
 */
import { memo, useCallback } from "react";

import { POST_RELATED_SIZES } from "./PostDetail.styles";
import type { PostDetailRelatedCardProps } from "./PostDetail.types";

import { trackBlogRelatedClicked } from "../../analytics";
import { toBlogLanguage } from "@/shared/config";
import { routes } from "@/shared/config/routes";
import { AppImage, ContentCard, IMAGE_PLACEHOLDER } from "@/shared/ui";

const PostDetailRelatedCard = memo<PostDetailRelatedCardProps>(
  ({ from, post, index }) => {
    const track = useCallback(
      () => trackBlogRelatedClicked(from, post, index),
      [from, post, index],
    );
    return (
      <ContentCard
        ratio="landscape"
        fixedTextHeight
        title={post.title}
        metadata={post.author.name}
        href={routes.blog.detail(post.slug, toBlogLanguage(post.language))}
        onClick={track}
        media={
          <AppImage
            uri={post.coverImageUrl ?? ""}
            fallback={IMAGE_PLACEHOLDER}
            sizes={POST_RELATED_SIZES}
          />
        }
      />
    );
  },
);

PostDetailRelatedCard.displayName = "PostDetailRelatedCard";

export default PostDetailRelatedCard;
